import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import LoginPage from '../pages/LoginPage.vue';
import Home from "@/pages/Home.vue";
import thongkebenhnhan from "@/pages/Thongkebenhnhan.vue";
import thongkedoanhthu from "@/pages/Thongkedoanhthu.vue";
import infoPage from "@/pages/InfoPage.vue";
import infoRealTimePage from "@/pages/InfoRealTimePage.vue";
import thongKeDieuTri from "@/pages/ThongKeDieuTri.vue";
import thongKeDieuTriTrucTuyen from "@/pages/ThongKeDieuTriTrucTuyen.vue";
import thongKeDieuTriTrongThoiGian from "@/pages/ThongKeDieuTriTrongThoiGian.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: '/login',
    name: 'login',
    component: LoginPage,
    props: true
  },
  {
    path: '/home',
    name: 'home',
    component: Home,
    props: true
  },
  {
    path: '/thongkebenhnhan',
    name: 'thongkebenhnhan',
    component: thongkebenhnhan,
    props: true
  },
  {
    path: '/thongkedoanhthu',
    name: 'thongkedoanhthu',
    component: thongkedoanhthu,
    props: true
  },
  {
    path: '/',
    name: 'thongtin',
    component: thongKeDieuTri,
    props: true
  },
  {
    path: '/thongtintructuyen',
    name: 'thongtintructuyen',
    component: infoRealTimePage,
    props: true
  },
  {
    path: '/thongKeDieuTri',
    name: 'thongKeDieuTri',
    component: thongKeDieuTri,
    props: true
  },
  {
    path: '/thongKeDieuTriTrucTuyen',
    name: 'thongKeDieuTriTrucTuyen',
    component: thongKeDieuTriTrucTuyen,
    props: true
  },
  {
    path: '/thongKeDieuTriTrongThoiGian',
    name: 'thongKeDieuTriTrongThoiGian',
    component: thongKeDieuTriTrongThoiGian,
    props: true
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
